import React from 'react';

import { BsFillCartCheckFill, BsFillCartFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart, removeFromCart } from '../Slices/cart/Cart';
import { FcDeleteRow } from 'react-icons/fc';

function ResponsiveTable({cart,status}) {
  const cartlist=useSelector(state=>state.cart);

  const weburl=useSelector(state=>state.constants.weburl);
  const dispatch=useDispatch();
  return (
    <div className=" mt-6 overflow-x-auto rounded-sm shadow-sm shadow-gray-300">
      <table className="min-w-full divide-y divide-gray-200 ">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SR</th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product</th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Size</th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Color</th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Quantity</th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{status==='wish'?'Add To Cart':'Remove'}</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
     {cart.map((item,index)=>(

   
        <tr key={index}>
            <td  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{++index}</td>
            <td className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
<div className='flex justify-start items-center'>
<div className='w-36 h-36 p-2 shadow-sm shadow-gray-300'>
<img alt='cartimage' src={`${weburl}/${item.image}`} className='w-[100%] h-[100%] object-cover'></img>

</div>
<div className='ml-6 w-36 '>
<h1 className='font-serif '>{item.name} </h1>
</div>
</div>

            </td>
            <td  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{item.sizeName}</td>
            <td  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{item.colorName}</td>
            <td  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{item.unitsaleprice}</td>
            <td  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{item.qty}</td>
            <td  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{item.qty*item.unitsaleprice}</td>
            <td  className=" py-20 text-left text-xs font-medium text-gray-500 uppercase tracking-wider flex items-baseline  justify-center">

{status==='wish'?

cartlist.some(cartlist=>cartlist.id===item.id)?(
  

  
  
  <BsFillCartCheckFill  size={30} className=' duration-700 text-red-700 transition-all cursor-pointer'  onClick={()=>dispatch(removeFromCart(item))}/>
 
  
  ):
  <BsFillCartFill   size={30} className=' text-gray-600 duration-700 transition-all'  onClick={()=>dispatch(addToCart(item))}/>
  

:
<FcDeleteRow size={30}  onClick={()=>dispatch(removeFromCart(item))}/>

}

            </td>
          </tr>
  ))}
          
        
        </tbody>
      </table>
    </div>



  );
}

export default ResponsiveTable;
